import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaMapMarkerAlt, FaClock } from 'react-icons/fa';

const ShabbatSection: React.FC = () => {
  const { t } = useTranslation();
  return (
    <section
      id="shabbat"
      className="w-full flex flex-col items-center bg-[#a9b487]"
    >
      {/* Content */}
      <div className="w-full max-w-2xl mx-auto flex flex-col items-center text-center font-body py-16 text-lg text-[#f5f0e6]">
        <h1 className="font-cursive text-4xl font-bold mb-8 tracking-wide">{t('shabbat_chatan')}</h1>
        <div className="space-y-4 px-4">
          <p className="text-lg">{t('please_join')}</p>
          <p className="text-lg">{t('saturday_kiddush')}</p>
          <div className="w-24 border-t border-[#f5f0e6]/40 my-6 mx-auto"></div>
          <p className="text-lg">{t('synagogue')}</p>
          <p className="text-base sm:text-lg">
            <FaMapMarkerAlt className="inline-block w-4 h-4 mr-1 align-text-bottom" />
            <a href="https://maps.google.com/?q=Ben+Yehuda+86+Tel+Aviv-Yafo" target="_blank" rel="noopener noreferrer" className="underline hover:no-underline text-[#f5f0e6]">{t('synagogue_address')}</a>
          </p>
          <p className="text-base sm:text-lg">
            <FaClock className="inline-block w-4 h-4 mr-1 align-text-bottom" />
            30.05.2026 {t('from_time')} 9:30-12:00
          </p>
          <p className="text-lg mt-4">{t('followed_by_kiddush')}</p>
        </div>
      </div>
    </section>
  );
};

export default ShabbatSection;
